import { render, staticRenderFns } from "./scratch_dialogue.vue?vue&type=template&id=4e74774a&scoped=true&"
import script from "./scratch_dialogue.vue?vue&type=script&lang=js&"
export * from "./scratch_dialogue.vue?vue&type=script&lang=js&"
import style0 from "./scratch_dialogue.vue?vue&type=style&index=0&id=4e74774a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e74774a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
